import { css, SerializedStyles } from "@emotion/react"
import { Icon } from "source/shared/components/Icon"

const iconSymbols = {
  play: "services#play",
  pause: "services#pause",
  skipBack: "general#reload",
  skipForward: "general#reload",
} as const

type IconName = keyof typeof iconSymbols

interface ControlButtonProps {
  icon: IconName
  label: string
  onClick: () => void
  buttonStyle: SerializedStyles
}

export function ControlButton({
  icon,
  label,
  onClick,
  buttonStyle,
}: ControlButtonProps) {
  return (
    <button css={buttonStyle} onClick={onClick} aria-label={label}>
      <Icon
        symbol={iconSymbols[icon]}
        css={icon === "skipForward" && styles.flipped}
      />
    </button>
  )
}

interface ControlButtonStyleProps {
  size: number
  iconSize: number
  iconColor: string
}

export function controlButtonStyle({
  size,
  iconSize,
  iconColor,
}: ControlButtonStyleProps) {
  return css`
    width: ${size}px;
    height: ${size}px;
    border-radius: ${size / 2}px;
    background-color: transparent;
    box-shadow: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${iconColor};

    svg {
      width: ${iconSize}px;
      height: ${iconSize}px;
    }
  `
}

const styles = {
  flipped: css`
    transform: scaleX(-1);
  `,
}
